export default __webpack_public_path__ + "static/media/Screenshot 2021-03-03 111234.bc95a166.png";